import React, { useRef, useState } from 'react'

const Otp = ({ styles, onVerifyOtp }) => {

    const OTP_LENGTH = 6;
    const [otp, setOtp] = useState(Array(OTP_LENGTH).fill(''));
    const inputsRef = useRef([]);

    const handleChange = (e, index) => {
        const value = e.target.value;

        // Allow only alphanumeric (A-Z, a-z, 0-9)
        if (!/^[a-zA-Z0-9]?$/.test(value)) return;

        const newOtp = [...otp];
        newOtp[index] = value.toUpperCase();
        setOtp(newOtp);

        // Move to next input automatically
        if (value && index < OTP_LENGTH - 1) {
            inputsRef.current[index + 1].focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace') {
            if (!otp[index] && index > 0) {
                inputsRef.current[index - 1].focus();
            }
        }
    };

    const handlePaste = (e) => {
        const pastedData = e.clipboardData
            .getData('text')
            .slice(0, OTP_LENGTH)
            .toUpperCase();

        if (!/^[A-Z0-9]+$/.test(pastedData)) return;

        const newOtp = pastedData.split('');
        while (newOtp.length < OTP_LENGTH) newOtp.push('');

        setOtp(newOtp);

        const lastIndex = Math.min(pastedData.length - 1, OTP_LENGTH - 1);
        inputsRef.current[lastIndex]?.focus();
    };

    const handleVerify = () => {
        const enteredOtp = otp.join('');

        if (enteredOtp.length !== OTP_LENGTH) {
            alert('Please enter complete OTP');
            return;
        }

        onVerifyOtp(enteredOtp);
    };

    return (
        <div className='h-100'>
            <div className='container-fluid h-100'>
                <div className='row h-100'>
                    <div className='col-md-12 h-100'>
                        <div className={`${styles['otp-box']}`}>
                            <div className={`${styles['can-title']} mb-0 px-2 pt-3`}>Verify Student via OTP</div>
                            <div className={`${styles['can-paragraph']} mb-0 px-2`}>Enter the unique OTP provided to the student to access their profile and application details.</div>
                            <hr />
                            <div className={`${styles['inner-otp']} mb-2 mx-3`}>
                                <div>
                                    <img src='/assets/images/otp-icon.svg' alt='profile image' className='img-fluid' />
                                    <h5 className={`${styles['otp-title']} my-2`}>OTP Verification</h5>
                                    <p className='mb-4'>Enter your OTP below</p>


                                    <div className='d-flex justify-content-center gap-3'
                                        onPaste={handlePaste}
                                    >

                                        {otp.map((digit, index) => (
                                            <input
                                                key={index}
                                                ref={(el) =>
                                                    (inputsRef.current[index] = el)
                                                }
                                                type='text'
                                                maxLength={1}
                                                value={digit}
                                                className={`${styles['number-box']}`}
                                                onChange={(e) =>
                                                    handleChange(e, index)
                                                }
                                                onKeyDown={(e) =>
                                                    handleKeyDown(e, index)
                                                }
                                            />
                                        ))}

                                    </div>
                                    <button
                                        className={`${styles['btn-ctm']} btn py-1 px-5 my-3`}
                                        onClick={handleVerify}
                                    >
                                        Verify
                                    </button>
                                    <p>OTP is unique per student and valid only during the campus drive.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Otp